import $http from "@/http";
import {createTasksApi} from '@/modules/tasks/api/tasksApi';

const tasksApi = createTasksApi($http);

export default {
    state: () => ({
        taskGroups: null,
    }),
    mutations: {
        pushTaskGroup (state, taskGroup) {
            if (state.taskGroups === null) {
                state.taskGroups = [];
            }
            state.taskGroups.push({
                id: taskGroup.id,
                title: taskGroup.title,
                task_title: taskGroup.task_title,
                task_content: taskGroup.task_content,
            });
        },
    },
    actions: {
        loadTaskGroups({state, commit}) {
            if (state.taskGroups === null) {
                state.taskGroups = [];
            }
            tasksApi.loadTaskGroups(function (res) {
                if (res.task_groups.length > 0) {
                    res.task_groups.forEach(function (taskGroup) {
                        commit('pushTaskGroup', taskGroup);
                    });
                }
            });
        },
    },
    getters: {
        taskGroups(state) {
            return state.taskGroups;
        },
    }
}
